export default __webpack_public_path__ + "static/media/big_unicorn.be45c251.png";